export default __webpack_public_path__ + "static/media/1942.d247a83c.png";